export class DocumentoGescorDTO {
  id: string;
  idRepository: string;
  hash: string;
  nome: string;
}
